import React from "react";
import { ButtonGroup, Button, Modal, FormGroup } from "react-bootstrap";
import { update } from "../../../utils/apiService";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";

import { updateVideo } from "../../../actions";

class MailingApproveReject extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false
    };

    this.approveMailing = this.approveMailing.bind(this);
    this.rejectMailing = this.rejectMailing.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }
  async approveMailing() {
    const { mailing, video, updateVideo } = this.props;
    let url = `/campaigns/${video.campaign_id}/videos/${video.id}/mailings/${
      mailing.id
    }`;
    let data = {
      mailing: {
        ...mailing,
        status: "Aprovado",
        rejection_motive: ""
      }
    };
    try {
      let response = await update(url, data);
      let updatedVideo = response.data;
      updateVideo(updatedVideo.campaign_id, updatedVideo);
      toastr.success("Mailing aprovado!");
    } catch (err) {
      toastr.error("Erro ao aprovar mailing.");
    }
  }
  async rejectMailing() {
    const { mailing, video, updateVideo } = this.props;
    let textInput = this.textInput.value;
    let url = `/campaigns/${video.campaign_id}/videos/${video.id}/mailings/${
      mailing.id
    }`;
    let data = {
      mailing: {
        ...mailing,
        status: "Rejeitado",
        rejection_motive: textInput
      }
    };
    try {
      let response = await update(url, data);
      let updatedVideo = response.data;
      updateVideo(updatedVideo.campaign_id, updatedVideo);
      toastr.success("Mailing rejeitado com sucesso!");
      this.setState({ showModal: false });
      this.resetInputs();
    } catch (err) {
      toastr.error("Erro ao rejeitar mailing.");
    }
  }
  resetInputs() {
    this.textInput.value = "";
  }
  handleClose() {
    this.setState({ showModal: false });
  }
  handleShow() {
    this.setState({ showModal: true });
  }
  render() {
    const { mailing } = this.props;
    return (
      <div>
        <ButtonGroup bsSize="xsmall">
          <Button
            onClick={this.approveMailing}
            bsStyle="success"
            disabled={mailing.status !== "Em análise"}
          >
            Aprovar
          </Button>
          <Button
            onClick={this.handleShow}
            bsStyle="danger"
            disabled={mailing.status !== "Em análise"}
          >
            Rejeitar
          </Button>
        </ButtonGroup>
        <Modal show={this.state.showModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Qual o motivo para rejeição do mailing?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <input
                className="form-control"
                type="text"
                ref={input => {
                  this.textInput = input;
                }}
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.rejectMailing} bsStyle="danger">
              Rejeitar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video));
  }
});

export default connect(null, mapDispatchToProps)(MailingApproveReject);



// WEBPACK FOOTER //
// ./src/components/pages/Mailing/MailingApproveReject.js